// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__+F86F","container":"gallery_container__54bPv","content":"gallery_content__n2KxC","image-col":"gallery_image-col__FH0ZX","video":"gallery_video__pwLm7"};